import {
  arrayOf, oneOfType, bool, number, shape, string
} from 'prop-types';

const identifiersShape = shape({
  canonicalUrl: string,
  itemId: string,
  brandName: string,
  productLabel: string,
  productType: string
});

const infoShape = shape({
  label: string
});

const mediaShape = shape({
  image: shape({
    url: string
  }),
  images: arrayOf(shape({
    url: string,
    type: string,
    subType: string,
    sizes: arrayOf(string)
  }))
});

const badgesShape = arrayOf(shape({
  label: string
}));

const pricingShape = shape({
  message: string,
  original: number,
  mapAboveOriginalPrice: bool,
  promotion: shape({
    dollarOff: number
  }),
  value: number,
});

const reviewsShape = shape({
  ratingsReviews: shape({
    totalReviews: string,
    averageRating: string
  })
});

export const drawerDataShape = shape({
  header: string,
  data: arrayOf(shape({
    title: string,
    sections: arrayOf(oneOfType([
      shape({
        header: string,
        text: string
      }),
      shape({
        header: string,
        list: arrayOf(string)
      })
    ]))
  }))
});

export const productShape = shape({
  itemId: string,
  dataSources: string,
  identifiers: identifiersShape,
  info: infoShape,
  media: mediaShape,
  badges: badgesShape,
  pricing: pricingShape,
  reviews: reviewsShape
});

const slotShape = shape({
  description: string,
  isRequired: bool,
  name: string,
  order: string
});

export const bundleProductShape = shape({
  category: string,
  description: string,
  idEndDate: string,
  idPromoDetails: string,
  idStartDate: string,
  isAnchor: bool,
  product: productShape,
  slot: slotShape
});

export const bundleShape = shape({
  metadata: shape({
    type: string
  }),
  products: arrayOf(bundleProductShape)
});

const fulfillmentShape = shape({
  fulfillmentOptions: arrayOf(shape({
    fulfillable: bool,
    type: string,
    services: arrayOf(shape({
      type: string,
      locations: arrayOf(shape({
        isAnchor: bool,
        inventory: shape({
          quantity: number
        })
      }))
    }))
  }))
});

export const anchorItemShape = shape({
  ...productShape.PropTypes,
  itemId: string,
  availabilityType: shape({
    discontinued: bool
  }),
  fulfillment: fulfillmentShape
});
